import React, { useState } from "react";
import styles from "./ReviseBox.module.css";

interface ReviseBoxProps {
  busy: boolean;
  error: string | null;
  onApply: (instructions: string) => void;
  onCancel: () => void;
}

// Inline "tell me what to change" panel shown under the rewrite/generated email.
// Presentational only — the parent owns the API call, busy and error state.
export default function ReviseBox({ busy, error, onApply, onCancel }: ReviseBoxProps) {
  const [text, setText] = useState("");
  const ready = text.trim().length > 0 && !busy;

  return (
    <div className={styles.box}>
      <label className={styles.label} htmlFor="revise-instructions">
        Tell me what to change
      </label>
      <textarea
        id="revise-instructions"
        className={styles.textarea}
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder="e.g. make it shorter, warmer, and add a line thanking them for their time"
        rows={3}
        disabled={busy}
        autoFocus
      />
      {error && <p className={styles.error}>{error}</p>}
      <div className={styles.actions}>
        <button
          className={`${styles.btn} ${styles.apply}`}
          onClick={() => ready && onApply(text.trim())}
          disabled={!ready}
          type="button"
        >
          {busy ? "Applying…" : "Apply changes"}
        </button>
        <button className={`${styles.btn} ${styles.cancel}`} onClick={onCancel} disabled={busy} type="button">
          Cancel
        </button>
      </div>
    </div>
  );
}
